/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Trigger/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import Selected from './Selected/index'
import TysiaIconArrowDown from 'DesignSystem/Svgs/TysiaIconArrowDown/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Trigger({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/Old/AppointmentSelect/Content/Content/Content/Trigger"
  
}) {
let appointmentOverlayIsEmergencyValueData = fromData.useDataValue({ viewPath,
context: 'appointment_overlay',
path: 'is_emergency',
})
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtTysiainputcontentBackgroundcolorPrimaryDisabled = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputContent.backgroundColor.primary.disabled'
        })
let dtTysiainputcontentBordercolorPrimaryDisabled = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputContent.borderColor.primary.disabled'
        })
  return (<React.Fragment
>
<div
  data-testid="Trigger.Horizontal"
  data-view-path={viewPath}
 style={{'--btlr-3-HFmAS': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-4-HFmAS': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bblr-5-HFmAS': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-6-HFmAS': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pt-7-HFmAS': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--pb-8-HFmAS': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--pl-9-HFmAS': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pr-10-HFmAS': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--bc-1-HFmAS': appointmentOverlayIsEmergencyValueData ? dtTysiainputcontentBackgroundcolorPrimaryDisabled : dtColorsWhite,'--bc-2-HFmAS': appointmentOverlayIsEmergencyValueData ? dtTysiainputcontentBordercolorPrimaryDisabled : dtColorsNeutral200}}
 className={`views-block ${styles.Horizontal}`}
>
<Selected
  viewPath={`${viewPath}/Selected`}
/>
<div
  data-testid="Trigger.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaIconArrowDown
  viewPath={`${viewPath}/TysiaIconArrowDown`}
/>
</div>
</div>
{children}
</React.Fragment>)
}